import { useAuth } from '@/shared/auth';
import { SupportHomeOnlyNotice } from '@/features/support-session';
import { AccountSecurityPage } from './AccountSecurityPage';

/** In einer Support-Sitzung gehört die Kontosicherheit zur Heimatsitzung, nicht zum Ziel-Workspace. */
export function AccountSecurityRoute() {
  return useAuth().support ? <SupportHomeOnlyNotice /> : <AccountSecurityPage />;
}
